/*
* 对白名单以外的路由跳转进行拦截然后跳转登录，同时判断用户权限，是否登录,等
 * */
import router from '@/routers'
import { getCookie } from '@/utils/cookies'
import utils from '@/utils'
const defaultCode = 'inesajxjy'
router.beforeEach((to, from, next) => {
  var d = utils.getQueryString('domain')
  if (!d) {
    d = defaultCode
  }
  if (getCookie(process.env.TOKEN_KEY)) {
    if (to.path == '/login' || to.path == '/findpwd') {
      next({path: '/', hash: ''})
    } else {
      if (!to.query.domain) {
        to.query.domain = d;
        next({path: to.path, query: to.query})
      } else {
        next()
      }
    }
  } else {
    if (to.path == '/course' || to.path.indexOf('/courseDetail') > -1) {
      next({path: '/'})
    } else {
      next()
    }
  }
})



// WEBPACK FOOTER //
// ./src/routers/guard.js